export const formatPhoneNumber = (phoneNumber: string): string => {
  const formattedPhone = phoneNumber.slice(0, 3) + "-" + phoneNumber.slice(3, 6) + "-" + phoneNumber.slice(6);

  return formattedPhone;
};
